/* RESPONSIBLE TEAM: team-standalone */

import { OnboardingGuideStepData } from '../definitions';
import type Platform from '../../platform';

export default class GenericOnboardingGuideStep extends OnboardingGuideStepData {
  protected platform: Platform;

  constructor(platform: Platform) {
    super(platform);
    this.platform = platform;
  }

  override get platformName() {
    return this.platform.platformKey;
  }

  override titleKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.generic.title`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.title`;
  }

  override descriptionKey(stepIdentifier: string): string {
    if (stepIdentifier === 'fin_sa_onboarding_add_support_content') {
      return `onboarding.getting-started.steps.${stepIdentifier}.generic.generic-description`;
    }
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.generic.description`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.description`;
  }

  override ctaKey(stepIdentifier: string): string {
    if (this.platformIsDependent(stepIdentifier)) {
      return `onboarding.getting-started.steps.${stepIdentifier}.generic.cta`;
    }
    return `onboarding.getting-started.steps.${stepIdentifier}.cta`;
  }

  private platformIsDependent(stepIdentifier: string): boolean {
    return (
      stepIdentifier === 'fin_sa_onboarding_add_integration' ||
      stepIdentifier === 'fin_sa_onboarding_connect_channels_and_turn_fin_live'
    );
  }

  override moreInfoLinkLabel(_stepIdentifier: string): string | null {
    return null;
  }

  override moreInfoArticleId(_stepIdentifier: string): number | undefined {
    return undefined;
  }

  override shouldShowConnectDrawer(_stepIdentifier: string): boolean {
    return false;
  }
}
